import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../../styles/TeamList.css';
import { useAdminData } from '../../../contexts/AdminDataContext';

const TeamIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="9" r="3" fill="#475569"/>
    <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    <circle cx="18" cy="11" r="2.5" fill="#475569" opacity="0.7"/>
    <path d="M21 20c0-2.21 1.791-4 4-4" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.7"/>
  </svg>
);

const TeamList = () => {
  const { allTeams, teamsLoading } = useAdminData();
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const filteredTeams = allTeams.filter(team => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return team.name.toLowerCase().includes(query);
    }
    return true;
  });

  const handleTeamClick = (teamId) => {
    navigate(`/admin/teams/${teamId}`);
  };

  return (
    <div className="team-list-page">
      <div className="page-header">
        <h1>Teams</h1>
        <Link to="/admin/teams/create" className="create-button">
          Create New Team
        </Link>
      </div>

        <div className="search-box">
          <input
            type="text"
            placeholder="Search teams..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

      {teamsLoading ? (
        <div className="loading-spinner"></div>
      ) : filteredTeams.length === 0 ? (
        <div className="no-results">No teams found</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Team</th>
            </tr>
          </thead>
          <tbody>
            {filteredTeams.map(team => (
              <tr
                key={team.id}
                onClick={() => handleTeamClick(team.id)}
                style={{ cursor: 'pointer' }}
              >
                <td className="team-cell">
                  <div className="team-list-item">
                    <div className="team-list-image-container">
                      {team.image ? (
                        <img
                          src={team.image}
                          alt={team.name}
                          className="team-list-image"
                          onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
                        />
                      ) : (
                        <TeamIcon className="team-list-icon" />
                      )}
                    </div>
                    <span className="team-name">{team.name}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TeamList;
